import { render } from "./Kitchen.vue?vue&type=template&id=3b59195e"
import script from "./Kitchen.vue?vue&type=script&lang=js"
export * from "./Kitchen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__